var _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57431 14.4988C1.94425 14.4988 1.38916 13.9527 1.38916 13.2211V3.05469H10.5V13.2211C10.5 13.9527 9.9449 14.4988 9.31489 14.4988H2.57431Z",
    stroke: "#3CB4E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 7,
    x2: 4.5,
    y2: 11,
    stroke: "#3CB4E5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 7,
    x2: 7.5,
    y2: 11,
    stroke: "#3CB4E5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 1.5,
    x2: 12,
    y2: 1.5,
    stroke: "#3CB4E5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 0.5,
    x2: 8,
    y2: 0.5,
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTrashCan);
export default __webpack_public_path__ + "static/media/blueTrashCan.4e0e03660a4e3bf4480af664f84ec4ce.svg";
export { ForwardRef as ReactComponent };